/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles
<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
         {{variantinfo}}
       </div>

<button  class="change-variant change-variant-btn Button-1" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">Select size</button>
       <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button  Button-1">
         {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
       </button>
       <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
         Delete from wishlist
       </button>

       			
             <div class="m-wishlist-buttons">
            <div>
              <button id="mswym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{product.id}}" class="m-wishlist-remove">Remove</button>
            </div>
            <div>
              <a href="#" class="m-wishlist-select">Select {{#product.options}}{{name}}{{/product.options}}</a>
            </div>
          </div>
                    <button class="topdiv">
            <h3>{{product.title}}</h3>
            <h3>{{ product.vendor }}</h3>
		  </button>
			<p><a href="{{product.url}}">Get Info</a></p> 
     <div class="mob-cart-buttons d-block d-lg-none">
			<button class="button-full mob-buttoncart" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{product.url}}" data-variant-id="" data-product-id="">
			<span>{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}</span>
			<span class="currentname"></span>
            </button>
			<a href="#" class="button button-gray-border soldout-gray button-full">Sold out</a>
		</div>
       
*/
var productCardMarkup = `<div class="swym-wishlist-grid">
   {{#products}} 
   <div class="col-md-3 wishlist-grid">
     <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
       <div class="main-list-wishlist">
         <div class="swym-wishlist-image-wrapper">
           <img alt="" class="swym-wishlist-image" src="{{iu}}">
         </div>
         <div class="grid-meta">
           <div class="product-wishlist-main">
             <button class="swym-is-button">
               <div class="swym-title-vendor swym-title-1">
                 {{bt}}
               </div>
               <div class="swym-title swym-title-1">
                 {{dt}}
               </div>
             </button>
             <div class="swym-product-price swym-text swym-text-1">
               <div class="swym-product-final-price swym-value">
                 {{cu}}{{pr}}
               </div>
           </div>
         </div>
         <div class="swym-size">
             {{vi}}
           </div>
         </div>
       </div>
       <div class="wishlist-buttons">
         <button class="change-variant change-variant-btn Button-1" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" data-variant-name="{{vi}}">Select size</button>
         <button id="swym-custom-add-toCartBtn" class="swym-add-to-cart-btn button-gray-border button-full Button-1 {{#isInCart}}item_added{{/isInCart}}" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}">
  			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
          </button>
          <button id="swym-custom-sold-out" class="button sold-out-button button-gray-border button-full hide-swym-button Button-1">
				Sold Out
			</button>
          <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="removewishlist swym-delete-btn">
            <span class="wishlist-delete-text">
             Delete from wishlist
           </span>
           <span class="wishlist-delete-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
            <path d="M4.1582 7.13672H5.34039V16.6367H4.1582V7.13672Z" fill="black"/>
            <path d="M7.13477 7.13672H8.31695V16.6367H7.13477V7.13672Z" fill="black"/>
            <path d="M10.0918 7.13672H11.274V16.6367H10.0918V7.13672Z" fill="black"/>
            <path d="M15.4533 2.36441H11.2944V0H4.15889V2.36441H0V5.93222H1.18218V19H14.25V5.93222H15.4321L15.4533 2.36441ZM5.36222 1.18222H10.1122V2.36441H5.36222V1.18222ZM1.20333 3.56782H14.2922V4.75H1.20333V3.56782ZM13.0678 17.8178H2.38556V5.93226H13.0678V17.8178Z" fill="black"/>
            </svg>
           </span>
          </button>
        </div>
     </a>
   </div>
   {{/products}}
</div>`;
  var variantModalMarkUp = `
    <div class="wishlist-sizedrawer" id="modal">
      <div class="wish-drawer-header">
		<div class="wishlist-m-header">
          <a href="{{product.url}}" class="selected_product">
            <div class="selected_product-grid">
              <img src="{{product.featured_image}}" alt="{{product.handle}}"/>
              <div class="product-info">
                <div class="product-title">
                  <h3>{{ product.vendor }}</h3>
                  <p>{{ product.title }}</p>
                </div>
                <p class="prduct-price-dr-mb" data-drawerPrice="{{ product.price }}">€<span>{{ product.price }}</span></p>
              </div>
            </div>
          </a>
		</div>
        <div class="wishheaderinr">
        Select {{#product.options}}{{name}}{{/product.options}}
        <button class="close-button" id="close-button">
          <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="1.06066" y1="1" x2="18" y2="17.9393" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></line>
          <line x1="18" y1="1.06066" x2="1.06066" y2="18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></line>
          </svg>
        </button>
        </div>
      </div>  
      <div class="modal-guts">		
        {{#product.options}}
          <div class="select-variant-{{name}}" id="user-options">
            {{#values}}
            <div class="sywm-radio">
			  <input type="radio" name="{{name}}" data-value="{{.}}" id="user-option{{.}}" data-vendor="{{product.vendor}}">
              <label for="user-option{{.}}">
              <span class="selecte_variant_icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                      <path d="M5.5252 11.657L0.575195 6.70702L1.9892 5.29302L5.5267 8.82652L5.5252 8.82802L14.0102 0.343018L15.4242 1.75702L6.9392 10.243L5.5262 11.656L5.5252 11.657Z" fill="black"></path>
                  </svg>
              </span>{{.}}</label>
            </div>
            {{/values}}
          </div> 
        {{/product.options}}
		
      </div>      
    </div>`;
function swymCallbackFn() {
  renderWishlistUI();
  countWishlist();  
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);
function showSoldOut() {
  console.log("sold out run")
  ATCButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  SOButtons = document.querySelectorAll("#swym-custom-sold-out");
  gridmain = document.querySelectorAll(".wishlist-grid");
  variantIDs = [];
  for(i=0; i<ATCButtons.length; i++){
    variantIDs[i] = ATCButtons[i].getAttribute("data-variant-id");
  }
  console.log(variantIDs)
  for(j=0; j<variantIDs.length; j++) {
    for(i=0; i<WishlistedProducts.length; i++){
      if(variantIDs[j] == WishlistedProducts[i].epi) {
        console.log(variantIDs[j],)
        if( WishlistedProducts[i].available == false) {
          ATCButtons[j].classList.add("hide-swym-button");
          SOButtons[j].classList.remove("hide-swym-button");
          gridmain[j].classList.add('disable-wishlist');
        }
      }
    }
  }
}

function renderWishlistUI() {
  _swat.fetch(function(products) {
    //console.log('Item',products);
    //WishlistedProducts = structuredClone(products);
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          //console.log("loop 2 started - " + j + " - " + fullProductDetails.variants[j]);
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
            //console.log("match found - " + fullProductDetails.variants[j].id);
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        } 
      });
    }
    currentUserWishlist = [];
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    currentUserWishlist = products;
    var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      //p.available = !_swat.platform.isEpiOOS(p.epi);
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
       
  });
  setTimeout(showSoldOut, 1000); 
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); 

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function(products) {
    //WishlistedProducts = structuredClone(products);
    WishlistedProducts = JSON.parse(JSON.stringify(products));
    for(let i = 0; i < WishlistedProducts.length; i++) {
      _swat.getProductDetails({
        du: WishlistedProducts[i].du,
        epi: WishlistedProducts[i].epi,
        empi: WishlistedProducts[i].empi
      },
      function(fullProductDetails) {
        for(let j = 0; j < fullProductDetails.variants.length; j++) {
          //console.log("loop 2 started - " + j + " - " + fullProductDetails.variants[j]);
          if(fullProductDetails.variants[j].id == WishlistedProducts[i].epi) {
            //console.log("match found - " + fullProductDetails.variants[j].id);
            WishlistedProducts[i].available = fullProductDetails.variants[j].available;
          }
        } 
      });
    }
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    var formattedWishlistedProducts = WishlistedProducts.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
      //p.available = !_swat.platform.isEpiOOS(p.epi);
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: WishlistedProducts
    });
    if(wishlistContentsContainer){
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else{
      console.log("Container not found, Wishlist Page element not found");
    }
  });
  setTimeout(showSoldOut, 1000);
  //console.log('loaded');
}


function onAddToCartClick(e) {
  e.preventDefault();
  e.stopPropagation();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.currentTarget.getAttribute("data-product-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function(c) {
    e.target.innerHTML = "Added to Cart";
    e.target.setAttribute("data-state-cart", "swym-added");    
    if(typeof load_cart == 'function'){
      load_cart();
      document.querySelector(".header-cart").click();
    }else{
      window.location.href = "/cart";
    }
  }, function(e) {
    console.log(e); 
  });
  countWishlist();
}
function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
    setTimeout(function() {
      countWishlist();  
    }, 1000);  
  });
}
function attachClickListeners() {
  var editVariantBtns = document.getElementsByClassName("change-variant-btn");
  for (var i = 0; i < editVariantBtns.length; i++) {
    //debugger
    //editVariantBtns[i].addEventListener('click', openVariantSelectionPopUp, false);
    //debugger
    editVariantBtns[i].addEventListener('click',function(e){
      e.preventDefault();
      console.log("change clicks")
      openVariantSelectionPopUp(this)
      return false
    })
  }
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  // var moreAction = document.getElementsByClassName("more-actions");
  // for (var i = 0; i < moreAction.length; i++) {
  //   moreAction[i].addEventListener('click', openVariantSelectionPopUp, false);
  // }
  // $(document).on('click','#mswym-remove-productBtn',onRemoveBtnClick);
  // $(document).on('click','.mob-buttoncart',onAddToCartClick);
}

function openVariantSelectionPopUp(e) {
  completeProductJson = {};
  var productId = e.getAttribute("data-product-id");
   console.log(productId)
  var variantId = e.getAttribute("data-variant-id");
  var variantTitle = e.getAttribute("data-variant-name");
  var du = e.getAttribute("data-url");
  var params = {
    du: du,
    empi: parseInt(productId),
    epi: parseInt(variantId)
  };
  variantButtonAttributes = {};
  variantButtonAttributes = params;  
  window._swat.getProductDetails(params, function(productJson) { 
	completeProductJson = productJson;
    productJson.du = du;
    renderModalUI(productJson);
    setTimeout(function(){ 
      // $('#mswym-remove-productBtn').attr('data-variant-id',variantId);
      // $('.mob-buttoncart').attr('data-variant-id',variantId);
      // $('.mob-buttoncart').attr('data-product-id',productId);
      // $('.currentname').text(variantTitle);      
    }, 1000);
    var jsonvariantid = productJson.variants;
    jsonvariantid.forEach(function(i,value){
      var allvarName = i.title;
      console.log("variantTitle",variantTitle)
       if(allvarName==variantTitle){
         document.querySelector('.sywm-radio [data-value="'+variantTitle+'"]').checked = true;
         if(i.available == false){
            document.querySelectorAll(".swym-add-to-cart").forEach((evttt) => {
              evvttt.style.display = "none";
            })
        }
       }
      // we have to change this code into javascrit =====================================
      // if(allvarName==variantTitle){
      //   $('.sywm-radio [data-value="'+variantTitle+'"]').prop('checked',true);
      //   if(i.available==false){
      //     $('.mob-buttoncart').hide();
      //     $('.soldout-gray').show();
      //   }
      // }
    });
  }); 
  countWishlist();
  //$(document).on('click','#mswym-remove-productBtn',onRemoveBtnClick);
  attachClickListeners();
}

function renderModalUI(productJson) {
  var modalElem = document.getElementById("modal-overlay");
  var variantMarkUpTemplate = SwymUtils.renderTemplateString(variantModalMarkUp, {
    product: productJson
  });
  //console.log('json',productJson);
  modalElem.innerHTML = variantMarkUpTemplate;
  attachModalEventListeners();
  document.querySelector(".swymmodal-overlay").classList.add("active");
  document.querySelector(".overlay-box").classList.add("active");

}

function attachModalEventListeners() {
  var closeButton = document.querySelector("#close-button");
  var saveButtons = document.querySelectorAll(".sywm-radio>input");
  closeButton.addEventListener("click", function() {
    document.querySelector(".swymmodal-overlay").classList.remove("active");
    document.querySelector(".overlay-box").classList.remove("active");
  });
  var Drawer_product_price = document.querySelector(".prduct-price-dr-mb");
  var Value_Drawer = Drawer_product_price.dataset.drawerprice;
  var Devided_vl = Number(Value_Drawer)/100;
  Drawer_product_price.querySelector("span").innerHTML = Devided_vl.toFixed(2);

  document.body.addEventListener('click', function(e){
    var OverLay = document.querySelector(".overlay-box");
    if(e.target == OverLay ){
      document.querySelector(".swymmodal-overlay").classList.remove("active");
      document.querySelector(".overlay-box").classList.remove("active");
    }
  });
  // saveButtona.addEventListener("click", function() {
  //   saveSelection();    
  //   document.querySelector(".swymmodal-overlay").classList.remove("active");
  //   document.querySelector(".overlay-box").classList.remove("active");
  // });
  for (var i = 0; i < saveButtons.length; i++) {
    saveButtons[i].addEventListener("click", function() {
      saveSelection(this.parentElement);
      this.closest('.sywm-radio').classList.add('active');
      setTimeout(function(){
        document.querySelector(".swymmodal-overlay").classList.remove("active");
        document.querySelector(".overlay-box").classList.remove("active");
        // document.querySelector('.favourite-mobile').classList.remove('open-ovaerlay');
      }, 1000);      
    });
  }
  // var mobAddToCartButtons = document.querySelectorAll(".mob-buttoncart");
  // for (var i = 0; i < mobAddToCartButtons.length; i++) {
  //   mobAddToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  // }
}
function saveSelection(product) {
  var userSelectionData = getSelectTagValues("#user-options");

  var variant = findVariant(userSelectionData);
  var vendor_list = product.querySelector("input").dataset.vendor;
  console.log(product)
  console.log("hkhkuihkui",variant,variantButtonAttributes)
  removeProductFromWishlist(variantButtonAttributes, function(removedProduct) {
    console.log(removedProduct)
    var newProductVariantAttributes = {
      empi: removedProduct.empi,
      epi: variant.id,
      du: removedProduct.du,
      cprops: {vendor:vendor_list},
    }
    addProductToWishlist(newProductVariantAttributes);
  });
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function findVariant(userSelectedOption) {
  var keys = Object.keys(userSelectedOption).filter(function(key) {
    return userSelectedOption[key] !== null && userSelectedOption[key] !== undefined;
  });

  var match = completeProductJson.variants.find(function(variant) {
    return keys.every(function(key, value) {
      return (variant[key] === userSelectedOption[key] && variant[value] === userSelectedOption[value]);
    });
  });
  return match;
}
function getSelectTagValues(selector) {
  var userSelection = {};
  if (typeof selector !== "undefined") {
    var elemNode = document.querySelectorAll(selector);
    elemNode.forEach(function(e,i){
      console.log(this,e)
      var optionValue = e.querySelector('input[type="radio"]:checked').dataset.value;
      var key = "option" + (i + 1);      
      var selectedValueObj = _defineProperty({}, key, optionValue);
      if (SwymUtils) {
        SwymUtils.extendDefaults(userSelection, selectedValueObj);
      }
    })
    return userSelection;
  } else {
    console.log("Invalid Option Selector");
  }
}
function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
        variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
function removeProductFromWishlist(old_product_variant, callback) {
  window._swat.removeFromWishList(old_product_variant, function(r) {
    console.log("Removing current Variant")
    callback(r);
  });
}
function addProductToWishlist(new_product_variant) {
  console.log(new_product_variant)
  window._swat.addToWishList(new_product_variant, function(r) {
    //       Added and re-render the Ui To reflect.
    renderWishlistUI();
  });
}
function checkVariantInCurrentWishlist(variant) {
  var exists = false;
  for (var i = 0; i < currentUserWishlist.length; i++) {
    if (currentUserWishlist[i].epi === variant.id) {
      exists = true;
      return exists;
    }
  }
  return exists;
}
function countWishlist(){
  window._swat.fetch( function(r) {
    console.log(r)
    if(r.length > 0){
        document.querySelector(".acc-order-empty-place").style.display="none";
    }else{
        document.querySelector(".acc-order-empty-place").style.display="grid";
    }
  });
}